import useFarwestCheckAverage, {
  farwestCheckAverageConfigs,
} from './useCheckAverage'
import useFwWingstopLocationDayPartPie, {
  fwWingstopLocationDayPartPieConfigs,
} from './useLocationDayPartPie'
import useFarwestSales, { farwestSalesConfigs } from './useSales'
import useFarwestSss, { farwestSssConfigs } from './useSss'
import {
  fwCompNoncompCohortCountConfig,
  fwCoreNoncoreCohortCountConfig,
  fwCoreNoncoreSssBreakdownConfig,
  fwMarketSssBreakdownConfig,
  useFwCompNoncompCohortCount,
  useFwCoreNoncoreCohortCount,
  useFwCoreNoncoreSssBreakdown,
  useFwMarketSssBreakdown,
} from './useSssBreakdown'
import useTrendLocationRevenueCenterSales, {
  fwWingstopTrendLocationRevenueCenterSalesConfigs,
} from './useTrendLocationRevenueCenterSales'

export const configs = {
  farwestSales: farwestSalesConfigs,
  farwestSss: farwestSssConfigs,
  farwestCheckAverage: farwestCheckAverageConfigs,
  fwWingstopLocationDayPartPie: fwWingstopLocationDayPartPieConfigs,
  fwWingstopTrendLocationRevenueCenterSales:
    fwWingstopTrendLocationRevenueCenterSalesConfigs,
  fwMarketSssBreakdown: fwMarketSssBreakdownConfig,
  fwCoreNoncoreSssBreakdown: fwCoreNoncoreSssBreakdownConfig,
  fwCoreNoncoreCohortCount: fwCoreNoncoreCohortCountConfig,
  fwCompNoncompCohortCount: fwCompNoncompCohortCountConfig,
}

export const api = {
  farwestSales: useFarwestSales,
  farwestSss: useFarwestSss,
  farwestCheckAverage: useFarwestCheckAverage,
  fwWingstopLocationDayPartPie: useFwWingstopLocationDayPartPie,
  fwWingstopTrendLocationRevenueCenterSales: useTrendLocationRevenueCenterSales,
  fwMarketSssBreakdown: useFwMarketSssBreakdown,
  fwCoreNoncoreSssBreakdown: useFwCoreNoncoreSssBreakdown,
  fwCoreNoncoreCohortCount: useFwCoreNoncoreCohortCount,
  fwCompNoncompCohortCount: useFwCompNoncompCohortCount,
}
